import { Alert, Box } from "@mui/material";
import {
	BooleanInput,
	DeleteButton,
	Edit,
	required,
	SaveButton,
	SimpleForm,
	TextInput,
	Toolbar,
	useRecordContext,
} from "react-admin";
import { RestoreButton } from "@/components/RestoreButton";

const PartnerEditToolbar = () => {
	const record = useRecordContext();

	return (
		<Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
			<SaveButton />
			<Box>
				{record?.deletedAt && <RestoreButton resource="partners" />}
				<DeleteButton />
			</Box>
		</Toolbar>
	);
};

const DeletedAlert = () => {
	const record = useRecordContext();
	if (!record?.deletedAt) return null;

	return (
		<Alert severity="warning" sx={{ mb: 2 }}>
			This partner was deleted on{" "}
			{new Date(record.deletedAt).toLocaleDateString()}. You can restore it
			using the Restore button below.
		</Alert>
	);
};

export const PartnerEdit = () => (
	<Edit>
		<DeletedAlert />
		<SimpleForm toolbar={<PartnerEditToolbar />}>
			<TextInput source="id" disabled />
			<TextInput source="name" validate={required()} fullWidth />
			<TextInput source="ownerId" disabled />
			<TextInput source="ownerEmail" disabled label="Owner Email" />
			<BooleanInput source="payoutEnabled" label="Payout Enabled" />
			<TextInput source="stripeAccountId" disabled label="Stripe Account ID" />
		</SimpleForm>
	</Edit>
);
